export const  json_ar = [
    {
        "name": "vod",
        "aos":"100",
        "image": "img1.jpeg",
        "descrption": "React app use Imdb API with search",
  "netifly":"https://vodyiz.netlify.app/",
  "git":"https://github.com/yizfar/vodyiz"

    },
    {
        "name": "debt ",
        "aos":"300",
        "image": "img2.jpeg",
        "descrption": " debt list js app with localstorage and loadsh function",
        "netifly":"https://debtlistyiz.netlify.app/",
        "git":"https://github.com/yizfar/debtlist"
    },
    {
        "name": "wether",
        "aos":"500",
        "image": "img3.jpeg",
        "descrption": "java script  use weather API",
        "netifly":"https://weatheryiz.netlify.app/",
        "git":"https://github.com/yizfar/weather"
    },
 
    {
        "name": "change",
        "aos":"700",
        "image": "img4.jpeg",
        "descrption": "React app use coinsAPI user can exchange coins to anther coins",
        "netifly":"https://exchangeyiz.netlify.app/",
        "git":"https://github.com/yizfar/change"
    
    },

    {
        "name": "nodejs",
        "aos":"800",
        "image": "img5.jpeg",
        "descrption": "Modern server side by nodejs (post,get etc)delete add update etc",
        "netifly":"https://nodejsyiz.herokuapp.com/",
        "git":"https://github.com/yizfar/nodejs"
    
    },
    {
        "name": "Lazy picture search",
        "aos":"900",
        "image": "img6.jpeg",
        "descrption": "  site you can search any picture with Api  with my Lazy Tech ",
        "netifly":"https://pictureyiz.netlify.app",
        "git":"https://github.com/yizfar/LazyPictuteSearch"
    
    },

]